const sizeScalesRoutes =
    [
        {
            path: '/sizescales',
            name: 'SizeScales',
            component: () => import(/* webpackChunName: "SizeScales" */ './views/index.vue')
        }
    ]
export default sizeScalesRoutes;